import { BrowserRouter, Routes, Route } from "react-router-dom";
import SurveyRedirect from "./SurveyRedirect";

function SurveyWrapper() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/survey/redirect" element={<SurveyRedirect />} />
        <Route path="*" element={"404 Not Found"} />
      </Routes>
    </BrowserRouter>
  );
}
export default SurveyWrapper;
